import React from 'react'

import aampeTheme from '../../constants/aampeTheme'

export default function basicInput({
    label,
    value,
    setValue,
    placeholder = '',
    wrapperStyle,
    labelStyle,
    inputStyle,
    description = null,
    isRequired = false,
    leadingIcon,
}) {
    return (
        <div style={{ ...wrapperStyle }}>
            <label
                style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '500',
                    marginBottom: aampeTheme.spacing4(2),
                    ...labelStyle,
                }}
            >
                {label}
                {isRequired ? ' *' : null}
            </label>
            <div style={{ position: 'relative' }}>
                {leadingIcon && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: '0px',
                            left: '0px',
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: aampeTheme.spacing4(2),
                            pointerEvents: 'none',
                        }}
                    >
                        {leadingIcon}
                    </div>
                )}
                <textarea
                    onChange={(e) => {
                        setValue(e.target.value)
                    }}
                    placeholder={placeholder}
                    style={{
                        borderRadius: '5px',
                        border: '1px solid rgba(157, 157, 184, 0.25)',
                        outlineColor: aampeTheme.colors.solidA01,
                        padding: aampeTheme.spacing4(2.5),
                        paddingLeft: leadingIcon
                            ? aampeTheme.spacing4(10)
                            : aampeTheme.spacing4(2),
                        height: '150px',
                        width: '400px',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        fontWeight: aampeTheme.weights.medium,
                        ...inputStyle,
                    }}
                    value={value}
                />
            </div>
            {description ? (
                <p
                    style={{
                        color: 'gray',
                        fontSize: '12px',
                        marginBottom: aampeTheme.spacing4(1),
                    }}
                >
                    {description}
                </p>
            ) : null}
        </div>
    )
}
